import React, { useEffect, useRef, useState } from "react";
import "../Style/blogs.css";

import BlogFeatures from "../components/blogfeature";
import BlogService from "../components/blogservice";
import ClientFeedback from "../components/Clientfeedback";
import PageFooter from "../components/Footer";


function BlogsPage() {
  const overlayRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (overlayRef.current) observer.observe(overlayRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="blogs-page">
        {/* CSS-only pattern layers, no images */}
        <div className="blogs-grid-pattern" aria-hidden="true" />
        <div className="blogs-blob blogs-blob-1" aria-hidden="true" />
        <div className="blogs-blob blogs-blob-2" aria-hidden="true" />
        <div className="blogs-blob blogs-blob-3" aria-hidden="true" />

        <div
          className={`blogs-overlay ${isVisible ? "blogs-visible" : ""}`}
          ref={overlayRef}
        >
          <div className="blogs-glass">
            {/* <img
              src={mpeoplesLogo}
              alt="MPeoples Logo"
              className="blogs-logo blogs-anim blogs-anim-1"
            /> */}

            <span className="blogs-eyebrow blogs-anim blogs-anim-2">
              Blog & Insights
            </span>

            <h1 className="blogs-title blogs-anim blogs-anim-3">
              The Innovation Behind Our Success
            </h1>

            <p className="blogs-description blogs-anim blogs-anim-4">
              At MPeoples, innovation drives everything we do—helping us create smarter solutions, deliver better results, and continuously evolve with changing business needs.
            </p>

            <button className="blogs-btn blogs-anim blogs-anim-5">
              Let&rsquo;s Build Together <span>↗</span>
            </button>
          </div>
        </div>
      </section>

      <BlogFeatures />
      <BlogService />
      <ClientFeedback />
      <PageFooter />
    </>
  );
}

export default BlogsPage;